<template>
    <v-layout fill-height row justify-center :class="flexClass">
        <v-progress-linear :indeterminate="true" v-if="progressBarVisible" class="ma-0 pa-0 progress-top"></v-progress-linear>
        <v-flex sm12 md10 lg8 p-0>
            <v-card class="fill-height">
                <v-breadcrumbs :items="breadCrumbs" class="dense">
                    <template v-slot:divider>
                        <v-icon>forward</v-icon>
                    </template>
                </v-breadcrumbs>
                <!--
                <v-card-title>
                    <h2>{{ $t("species") }}</h2>
                    <v-spacer></v-spacer>
                    <v-text-field
                        v-model="speciesSearch"
                        append-icon="search"
                        :label="$t('search')"
                        single-line
                        hide-details
                    ></v-text-field>
                </v-card-title>
                -->
                <v-tabs v-model="tab">
                    <v-tab>
                        <v-icon left>mdi-checkbox-multiple-blank-circle-outline</v-icon> {{ $t("rawMaterials") }}
                    </v-tab>
                    <v-tab-item>
                        <v-toolbar card prominent dense>
                            <v-tooltip
                                bottom
                                :disabled="true"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        flat
                                        v-on="on"
                                        @click="loadPrices"
                                    >
                                        <v-icon>mdi-reload</v-icon> {{ $t("reload") }}
                                    </v-btn>
                                </template>
                                <span>{{ $t("reload") }}</span>
                            </v-tooltip>
                            <v-tooltip
                                bottom
                                :disabled="true"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        flat
                                        v-on="on"
                                        :disabled="!acl.Create"
                                        @click="showNewPriceDlg"
                                    >
                                        <v-icon>mdi-plus-circle-outline</v-icon> {{ $t("create") }}
                                    </v-btn>
                                </template>
                                <span>{{ $t("create") }}</span>
                            </v-tooltip>
                            <v-tooltip
                                bottom
                                :disabled="true"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        flat
                                        v-on="on"
                                        :disabled="!selectedRow || !acl.Modify"
                                        @click="editItem(selectedRow)"
                                    >
                                        <v-icon>mdi-pencil-outline</v-icon> {{ $t("edit") }}
                                    </v-btn>
                                </template>
                                <span>{{ $t("edit") }}</span>
                            </v-tooltip>
                            <v-tooltip
                                bottom
                                :disabled="true"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        flat
                                        v-on="on"
                                        :disabled="!selectedRow || !acl.Delete"
                                        @click="deleteItemClick(selectedRow)"
                                    >
                                        <v-icon>mdi-delete-outline</v-icon> {{ $t("delete") }}
                                    </v-btn>
                                </template>
                                <span>{{ $t("delete") }}</span>
                            </v-tooltip>
                        </v-toolbar>

                        <v-card-text class="v-scrollable">
                            <v-flex xs12>
                                <v-select
                                    v-model="speciesId"
                                    :items="speciesFiltered"
                                    item-text="name"
                                    item-value="id"
                                    :label="$t('speciesAlt')"
                                    v-if="speciesFiltered.length > 0"
                                ></v-select>
                            </v-flex>

                            <v-data-table
                                hide-actions
                                :headers="computedHeaders"
                                :items="filteredData"
                                :search="pricesSearch"
                                class="dense-table"
                            >
                                <template v-slot:items="props">
                                    <tr
                                        @click="selectedRow = props.item"
                                        :class="{'grey darken-5': props.item === selectedRow}"
                                    >
                                        <td class="text-xs-left">{{ props.item.dMin }}</td>
                                        <td class="text-xs-right">{{ props.item.price }}</td>
                                        <!--
                                        <td class="justify-center layout px-0">
                                            <v-icon
                                                class="mr-2"
                                                @click="editItem(props.item)"
                                            >
                                                edit
                                            </v-icon>
                                            <v-icon
                                                @click="deleteItemClick(props.item)"
                                            >
                                                delete
                                            </v-icon>
                                        </td>
                                        -->
                                    </tr>
                                </template>
                                <template v-slot:no-results>
                                    <v-alert :value="true" color="error" icon="warning">
                                        {{ $t("youSearchFor") }}{{ speciesSearch }}{{ $t("foundNoResults") }}.
                                    </v-alert>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-tab-item>

                    <v-tab>
                        <v-icon left>mdi-dots-triangle</v-icon> {{ $t("sawWaste") }}
                    </v-tab>
                    <v-tab-item>
                        <v-toolbar card prominent dense>
                            <v-tooltip
                                bottom
                                :disabled="true"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        flat
                                        v-on="on"
                                        @click="updatePrices"
                                    >
                                        <v-icon>mdi-content-save-outline</v-icon> {{ $t("save") }}
                                    </v-btn>
                                </template>
                                <span>{{ $t("save") }}</span>
                            </v-tooltip>
                        </v-toolbar>

                        <v-card-text>
                            <v-container grid-list-md class="py-0">
                                <span
                                    class="body-1"
                                >{{ ($i18n.locale == 'ru'
                                    ? 'Если задать стоимость равной нулю, то отходы не будут учитываться в экономическом отчете. При использовании положительных значений итоговая стоимость раскроя повышается. Отрицательные же значения, наоборот, понижают стоимость (отходы пиления не приносят прибыли).'
                                    : 'If you set the value to zero, the waste will not be included in the economic report. If positive values are used, the final cost of cutting increases. Negative values, on the contrary, decrease the value (sawing waste does not bring profit).')
                                }}</span>

                                <v-flex xs12 class="mt-3">
                                    <v-layout wrap>
                                        <v-flex xs4>
                                            <v-text-field
                                                v-model="woodChipsPrice"
                                                :label="$t('woodChipsPriceM3')"
                                                required
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs4>
                                            <v-text-field
                                                v-model="sawdustPrice"
                                                :label="$t('sawdustPriceM3')"
                                                mr-2
                                                required
                                            ></v-text-field>
                                        </v-flex>
                                        <!-- <v-flex xs4>
                                            <v-text-field
                                                v-model="falseCorePricePrcnt"
                                                :label="$t('falseCorePricePrcnt')"
                                                :hint="$t('falseCorePricePrcnt')"
                                                :rules="[rules.percent]"
                                                suffix="%"
                                                mr-2
                                                required
                                            ></v-text-field>
                                        </v-flex> -->
                                    </v-layout>
                                </v-flex>
                            </v-container>
                        </v-card-text>
                    </v-tab-item>
                </v-tabs>
            </v-card>
            <edit-price-dialog ref="EditPriceDialog"/>
            <message-box       ref="MessageBox"/>
            <message-dialog    ref="MessageDialog"/>
            <v-alert
                :value="alert !== ''"
                :type="alertType"
                transition="scale-transition"
                class="bottom-alert"
            >
                {{ alert }}
            </v-alert>
        </v-flex>
    </v-layout>
</template>

<script>
    import EditPriceDialog from "@/components/dialogs/EditPriceDialog";
    import MessageBox      from "@/components/dialogs/MessageBox";
    import MessageDialog   from "@/components/dialogs/MessageDialog";

    export default {
        name: "PricesManagement",

        components: {
            EditPriceDialog,
            MessageBox,
            MessageDialog
        },

        data () {
            return {
                alert: "",
                alertType: "success",

                acl: {
                    Read:   false,
                    Create: false,
                    Modify: false,
                    Export: false,
                    Delete: false
                },
                breadCrumbs: [
                    { text: "Справочники", disabled: false },
                    { text: "Цены",        disabled: false }
                ],
                headers: [
                    { text: "id",               value: "id",    align: "center", sortable: true },
                    { text: "Мин. диаметр, мм", value: "minD",  align: "left",   sortable: true },
                    { text: "Цена",             value: "price", align: "right",  sortable: true }
                    //{ text: "Действие", value: "action",  align: "center", sortable: false }
                ],

                dialogWatcher: null,
                falseCorePricePrcnt: 0,
                hideIDs: true,
                loading: {
                    pricesInfo:  false,
                    speciesInfo: false
                },
                prices: [],
                pricesSearch: "",
                priceWatcher: null,
                rules: {
                    price:   value => (value >= 0 && value <= 100000) || this.$t("incorrectValue"),
                    percent: value => (value >= 0 && value <= 100) || this.$t("incorrectValue"),
                },
                sawdustPrice: 0,
                selected: [],
                selectedRow: null,
                speciesId: 1,
                species: [],
                woodChipsPrice: 0,
                tab: null
            }
        },

        computed: {
            computedHeaders () {
                if (this.hideIDs) {
                    return this.headers.filter(header => header.text !== "id");
                }

                return this.headers;
            },

            filteredData () {
                return this.prices.filter(data => {
                    return data.speciesId == this.speciesId ? data : false;
                })
            },

            flexClass () {
                return {
                    //lgUp: this.$vuetify.breakpoint.lgAndUp,
                    "md-up": this.$vuetify.breakpoint.mdAndUp
                }
            },

            progressBarVisible () {
                return this.loading.pricesInfo || this.loading.speciesInfo;
            },

            speciesFiltered () {
                return this.species.filter(item => this.$store.getters.user.settings.selectedSpecies.includes(item.id))
            },
        },

        watch: {
            alert: function (val) {
                let component = this;
                if (val !== "") {
                    setTimeout(() => {
                        component.alert = "";
                    }, 3000);
                }
            }
        },

        mounted () {
            if (!this.$store.getters.user.loggedIn) {
                if (!this.$noRedirect.includes(this.$router.currentRoute.path)) {
                    this.$router.push("/home");
                }
            }

            this.applyLocale();
            this.loadPrices();

            if (this.$store.getters.user.acl) {
                this.$store.getters.user.acl.forEach((aclRecord) => {
                    if (aclRecord.Module.Name == "prices") {
                        this.acl = aclRecord;
                    }
                });
            }

            this.$root.$on("localeChanged", () => { this.applyLocale(); });
        },

        methods: {
            /**
             * Применение локали
             */
            applyLocale () {
                this.headers = [
                    { text: "id",              value: "id",    align: "center", sortable: true },
                    { text: this.$t("minDmm"), value: "minD",  align: "left",   sortable: true },
                    { text: this.$t("price"),  value: "price", align: "right",  sortable: true }
                ];

                this.breadCrumbs = [
                    { text: this.$t("catalogs"), disabled: false },
                    { text: this.$t("prices"),   disabled: false }
                ];

                this.getSpecies();
            },


            /**
             * Удаление элемента
             *
             * @param {object} item Удаляемый элемент
             */
            deleteItem (item) {
                this.axios({
                    method: "delete",
                    url: `${this.$config.apiURL}prices/${item.id}/`,
                    withCredentials: true
                }).then(() => {
                    this.loadPrices();
                }).catch(error => {
                    if (error.response && error.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { window.location.reload(); }
                        );
                    } else if (error.response && error.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("cantDeletePrice") + ". " + this.$t("subscriptionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (error.response && error.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("cantDeleteprice") + ". " + this.$t("accessDenied"));
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantDeletePrice"));
                    }
                });
            },

            /**
             * Обработчик нажатия кнопки удаления элемента
             *
             * @param {object} item Удаляемый элемент
             */
            deleteItemClick (item) {
                // Удаление наблюдателя если установлен
                if (this.dialogWatcher !== null) {
                    this.dialogWatcher();
                }

                /* Отслеживание ответа в диалоге "Да/Нет" */
                this.dialogWatcher = this.$watch(
                    "$refs.MessageDialog.answer",
                    (val) => {
                        if (val) { this.deleteItem(item); }
                    }
                );

                this.$refs.MessageDialog.title       = this.$t("priceDelete");
                this.$refs.MessageDialog.messageText = this.$t("confirmPriceDelete");
                this.$refs.MessageDialog.dialog      = true;
            },

            /**
             * Отображение диалога редактирования
             *
             * @param {object} item Редактируемый элемент
             */
            editItem (item) {
                this.initPriceWatcher();
                this.$refs.EditPriceDialog.resetForm();
                this.$refs.EditPriceDialog.speciesId = this.speciesId;
                this.$refs.EditPriceDialog.priceId   = item.id;
                this.$refs.EditPriceDialog.dMin      = item.dMin;
                this.$refs.EditPriceDialog.price     = item.price;
                this.$refs.EditPriceDialog.dialog    = true;
            },

            /**
             * Получение данных о породах
             */
            getSpecies () {
                this.loading.speciesInfo = true;
                this.axios.get(`${this.$config.apiURL}species/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let speciesInfo = response.data.species

                            this.species = [];

                            speciesInfo.forEach((item) => {
                                this.species.push({
                                    id:   Number(item.id),
                                    name: this.$t(item.Name)
                                });

                                if (this.speciesId == 0) {
                                    this.speciesId = item.id;
                                }
                            });

                            this.species.sort((a, b) => a.name > b.name);
                        }

                        this.loading.speciesInfo = false;
                    })
                    .catch(error => {
                        this.loading.speciesInfo = false;

                        if (error.response && error.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadSpeciesData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            /* Отслеживание нажатия кнопки ok в диалоге */
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadSpeciesData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadSpeciesData"));
                        }
                    });
            },

            /**
             * Инициализация наблюдателя за измененим цены
             */
            initPriceWatcher () {
                if (this.priceWatcher !== null) {
                    this.priceWatcher();
                }

                /* Отслеживание состояния флага изменения данных */
                this.priceWatcher = this.$watch(
                    "$refs.EditPriceDialog.dataUpdated",
                    (val) => {
                        if (val) {
                            this.dataSavedAlert = true;
                            this.alert = this.$t("dataSaved");
                            this.loadPrices();
                        }
                    }
                );
            },

            /**
             * Загрузка цен
             */
            loadPrices () {
                this.loading.pricesInfo = true;

                this.axios.get(`${this.$config.apiURL}prices/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let pricesInfo = response.data.prices

                            this.prices = [];

                            pricesInfo.forEach((item) => {
                                this.prices.push({
                                    id:        Number(item.id),
                                    speciesId: Number(item.SpeciesId),
                                    dMin:      item.DMin,
                                    price:     item.Price
                                });
                                if (this.speciesId == 0) {
                                    this.speciesId = item.id;
                                }
                            });
                        }

                        this.loading.pricesInfo = false;
                    })
                    .catch(error => {
                        this.loading.pricesInfo = false;

                        if (error.response && error.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadPricesData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            /* Отслеживание нажатия кнопки ok в диалоге */
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadPricesData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadPricesData"));
                        }
                    });

                    this.axios.get(`${this.$config.apiURL}settings/param/raw_prices/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let rawPricesInfo = response.data.settings;
                            this.sawdustPrice        = rawPricesInfo.saw_dust;
                            this.woodChipsPrice      = rawPricesInfo.chips;
                            this.falseCorePricePrcnt = rawPricesInfo.false_core;
                        }
                        this.loading.pricesInfo = false;
                    })
                    .catch(error => {
                        this.loading.pricesInfo = false;

                        if (error.response && error.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadPricesData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            /* Отслеживание нажатия кнопки ok в диалоге */
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadPricesData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadPricesData"));
                        }
                    });

            },

            /**
             * Сохранение стоимости щепы, опилок и пиломатериалов с ложным ядром
             */
            updatePrices () {
                /*
                let formData = new FormData();

                formData.append("name", "raw_prices");
                formData.append("data", JSON.stringify(
                    {
                        chips:      parseFloat(this.woodChipsPrice),
                        saw_dust:   parseFloat(this.sawdustPrice),
                        false_core: parseFloat(this.falseCorePricePrcnt)
                    }
                ));
                */

                this.axios({
                    method: "patch",
                    /*
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                    */
                    url:  `${this.$config.apiURL}settings/param/`,
                    data: {
                        name: "raw_prices",
                        data: {
                            chips:      parseFloat(this.woodChipsPrice),
                            saw_dust:   parseFloat(this.sawdustPrice),
                            false_core: parseFloat(this.falseCorePricePrcnt)
                        }
                    },
                    withCredentials: true
                }).then(() => {
                    //this.showMessageBox(this.$t("information"), this.$t("userUpdated"));
                    this.alertType = "success";
                    this.alert     = this.$t("dataUpdated");
                }).catch(error => {
                    if (error.response && error.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { window.location.reload(); }
                        );
                    } else if (error.response && error.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("cantUpdatePrices") + ". " + this.$t("subscriptionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (error.response && error.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("cantUpdatePrices") + ". " + this.$t("accessDenied"));
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantUpdatePrices"));
                    }
                });
            },

            /**
             * Отображение сообщения
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            },

            /**
             * Отображение диалога добавления цены
             */
            showNewPriceDlg () {
                this.initPriceWatcher();
                this.$refs.EditPriceDialog.resetForm();
                this.$refs.EditPriceDialog.speciesId = this.speciesId;
                this.$refs.EditPriceDialog.dialog    = true;
            }
        }
    }
</script>
